import React, { useState, useEffect } from "react";
import "../../../../client/assets/css/cms/Country.css";
import DataTable from "react-data-table-component";
import Form from "react-bootstrap/Form";
import Row from "react-bootstrap/Row";
import Col from "react-bootstrap/Col";
import Select from "react-select";
import { RiEdit2Line } from "react-icons/ri";
import { BsSearch } from "react-icons/bs";
import { Link, useParams } from "react-router-dom";
import { BsEye } from "react-icons/bs";
import { useNavigate } from "react-router-dom";
import { useDispatch, useSelector } from "react-redux";
import CommonModal from "../../utils/commonModal";
import Loading from "../../../components/utils/loader";
import {
  CUSTOM_STYLE_PERMISSION_DATA_TABLE,
  COUNTRY_STATUS,
} from "../../../constants/cms";
import Box from "@mui/material/Box";
import AdapterDateFns from "@mui/lab/AdapterDateFns";
import LocalizationProvider from "@mui/lab/LocalizationProvider";
import DesktopDatePicker from "@mui/lab/DatePicker";
import CountryOverview from "./overview";
import BasicDetail from "./basicDetail";
import ContentDetail from "./contentDetail";
import Gallery from "./gallery";
import Faqs from "./faqs";
import Button from "react-bootstrap/Button";
import { getCountryList } from "../../../../store/slices/country";

function Country(props) {
  const [sdate, setSdate] = React.useState(null);
  const { countryListData, countryListLoading } = useSelector(
    (state) => state.cmsCountry
  );
  const dispatch = useDispatch();
  const [open, setOpen] = useState(false);
  const [itemToDelete, setItemToDelete] = useState(null);
  const [ndate, setNdate] = React.useState(null);
  const [totalRows, setTotalRows] = useState(0);
  const [perPage, setPerPage] = useState(10);
  const [tableData, setTableData] = useState(null);
  const [totalCountries, setTotalCountries] = useState(null);
  const [publisedCountries, setPublisedCountries] = useState(null);
  const [unpublishedCountries, setUnpublishedCountries] = useState(null);
  const [tableCustomData, setTableCustomData] = useState([
    {
      name: "Id",
      selector: (row) => row.id,
    },
    {
      name: "Name",
      selector: (row) => row.country_name,
      center: "true",
    },
    {
      name: "Created",
      selector: (row) => row.created,
      center: "true",
    },
    {
      name: "Updated",
      selector: (row) => row.last_updated,
      center: "true",
    },
    {
      name: "Status",
      selector: (row) => (row.status ? "Published" : "Unpublished"),
      center: "true",
    },
    {
      name: "Action",
      cell: (row) => (
        <div>
          <Link to={`/cms/country/${row.id}/overview`}>
            <span className={"icon_edit"}>
              <RiEdit2Line />
            </span>
          </Link>
          {row?.status && row?.alias ? (
            <a href={row?.alias} target="_blank" rel="noopener noreferrer">
            <span className={"icon_view"}>
              <BsEye />
            </span>
          </a>
          ) : null }
        </div>
      ),
      allowOverflow: true,
      center: "true",
    },
  ]);
  const { param, id } = useParams();
  const [name, setName] = useState("");
  const navigate = useNavigate();
  const [status, setStatus] = useState(null);
  const [currentPage, setCurrentPage] = useState(1);
  const [activeComponent, setActiveComponent] = useState();
  const COUNTRY_ROUTES = [
    { path: "overview", exact: true, value: "", element: <CountryOverview /> },
    {
      path: "basic-detail",
      exact: true,
      value: "",
      element: <BasicDetail />,
    },
    {
      path: "content-detail",
      exact: true,
      value: "",
      element: <ContentDetail />,
    },
    {
      path: "gallery",
      exact: true,
      value: "",
      element: <Gallery />,
    },
    {
      path: "faqs",
      exact: true,
      value: "",
      element: <Faqs />,
    },
  ];

  useEffect(() => {
    if (countryListData) {
      setTableData(countryListData?.country_list?.results);
      setTotalRows(countryListData?.country_list?.totalRows);
      setTotalCountries(countryListData?.total_countries)
      setPublisedCountries(countryListData?.published_countries)
      setUnpublishedCountries(countryListData?.unpublished_countries)
    }
  }, [countryListData]);

  useEffect(() => {
    if (currentPage) {
      if (!id) {
        let params = {};
        params.page = currentPage;
        params.itemsOnPage = perPage;
        dispatch(getCountryList(params));
        setSdate(null);
        setNdate(null);
      }
    }
  }, [currentPage]);

  const handlePageChange = (page) => {
    setCurrentPage(page);
  };

  const handlePerRowsChange = (newPerPage, page) => {
    let params = {};
    params.page = page;
    params.itemsOnPage = newPerPage;
    dispatch(getCountryList(params));
    setPerPage(newPerPage);
  };

  useEffect(() => {
    if (param) {
      let activeComponent = COUNTRY_ROUTES.find((obj) => {
        if (obj.path == param) {
          return obj;
        }
      })?.element;
      if (activeComponent) {
        setActiveComponent(activeComponent);
      } else {
        setActiveComponent(COUNTRY_ROUTES[0].element);
      }
    } else {
      setActiveComponent(null);
    }
  }, [param]);

  const handleSearch = (e) => {
    e.preventDefault();
    let params = {};
    params.name = name;
    params.status = status && status.value;
    params.date_from = sdate;
    params.date_to = ndate;
    if (
      params.name != "" ||
      params.status != null ||
      params.date_from != "" ||
      params.date_to != ""
    ) {
      dispatch(getCountryList(params));
    }
  };

  return (
    <>
      <div className={"news_letter"}>
        <h4 className={"news_letter_heading"}>All Country</h4>
      </div>
      {activeComponent}
      {!activeComponent && (
        <div>
          <div className={"overview"}>
            <div className={"country"}>
              <Row className="mb-4">
                <Col>
                  <div className={"country_header"}>
                    <h2>{totalCountries}</h2>
                    <h3>Total Number Of Countries</h3>
                  </div>
                </Col>
                <Col>
                  <div className={"country_header"}>
                    <h2>{publisedCountries}</h2>
                    <h4>Published Countries</h4>
                  </div>
                </Col>
                <Col>
                  <div className={"country_header"}>
                    <h2>{unpublishedCountries}</h2>
                    <h4>Unpublished Countries</h4>
                  </div>
                </Col>
              </Row>
              <Row>
                <Form>
                  <div className={"examfilter"}>
                    <h4 className={"examfilter_heading"}>
                      Filter The List Of Countries
                    </h4>
                    <Row>
                      <Col>
                        <Form.Group className="mb-3" controlId="title">
                          <Form.Label>Title</Form.Label>
                          <Form.Control
                            type="text"
                            className={"input_pd"}
                            value={name}
                            placeholder="Enter Name"
                            onChange={(event) => {
                              setName(event.target.value);
                            }}
                          />
                        </Form.Group>
                      </Col>
                      <Col>
                        <Form.Group className="mb-3" controlId="status">
                          <Form.Label> Publishing Status</Form.Label>
                          <Select
                            onChange={(obj) => setStatus(obj)}
                            name="Status"
                            getOptionLabel={(option) => option.label}
                            getOptionValue={(option) => option.value}
                            options={COUNTRY_STATUS}
                            value={status}
                            escapeClearsValue={true}
                            isClearable={true}
                          />
                        </Form.Group>
                      </Col>
                      <Col>
                        <Form.Group
                          className="mb-3 date_input"
                          controlId="startDate"
                        >
                          <Form.Label>Start Date</Form.Label>
                          <LocalizationProvider dateAdapter={AdapterDateFns}>
                            <DesktopDatePicker
                              label="Custom input"
                              value={sdate}
                              onChange={(sValue) => {
                                if (sValue) {
                                  setSdate(sValue.toISOString());
                                } else {
                                  setSdate(null);
                                }
                              }}
                              renderInput={({
                                inputRef,
                                inputProps,
                                InputProps,
                              }) => (
                                <Box
                                  sx={{ display: "flex", alignItems: "center" }}
                                >
                                  <Form.Control
                                    ref={inputRef}
                                    {...inputProps}
                                    className={"input_pd"}
                                  />
                                  {InputProps?.endAdornment}
                                  {sdate && (
                                    <Button
                                      variant="link"
                                      onClick={() => setSdate(null)}
                                      className={"cross-button"}
                                    >
                                      &#x2716;
                                    </Button>
                                  )}
                                </Box>
                              )}
                            />
                          </LocalizationProvider>
                        </Form.Group>
                      </Col>
                      <Col>
                        <Form.Group
                          className="mb-3 date_input"
                          controlId="endtDate"
                        >
                          <Form.Label>End Date</Form.Label>
                          <LocalizationProvider dateAdapter={AdapterDateFns}>
                            <DesktopDatePicker
                              label="Custom input"
                              value={ndate}
                              minDate={new Date(sdate)}
                              onChange={(eValue) => {
                                setNdate(eValue.toISOString());
                              }}
                              renderInput={({
                                inputRef,
                                inputProps,
                                InputProps,
                              }) => (
                                <Box
                                  sx={{ display: "flex", alignItems: "center" }}
                                >
                                  <Form.Control
                                    ref={inputRef}
                                    {...inputProps}
                                    className={"input_pd"}
                                  />
                                  {InputProps?.endAdornment}
                                  {ndate && (
                                    <Button
                                      variant="link"
                                      onClick={() => setNdate(null)}
                                      className={"cross-button"}
                                    >
                                      &#x2716;
                                    </Button>
                                  )}
                                </Box>
                              )}
                            />
                          </LocalizationProvider>
                        </Form.Group>
                      </Col>
                    </Row>
                    <Row>
                      <Col>
                        <Form.Group>
                          <button
                            className={"exam_button"}
                            type="submit"
                            onClick={(e) => handleSearch(e)}
                          >
                            Search
                            <span>
                              {" "}
                              <BsSearch />
                            </span>
                          </button>
                        </Form.Group>
                      </Col>
                    </Row>
                  </div>
                </Form>
              </Row>
            </div>
          </div>
          <div className={"all_task"} style={{ marginTop: "40px" }}>
            <div className={"examfilter"}>
              <div className={"tablestrip"}>
                <div className={"tablestrip_left"}>
                  <h4 className={"examfilter_heading"}>Manage Countries</h4>
                </div>
              </div>

              <div className={"exam_table_box"} style={{ marginTop: "20px" }}>
                {countryListLoading && <Loading />}
                {tableData && (
                  <DataTable
                    columns={tableCustomData}
                    data={tableData}
                    customStyles={CUSTOM_STYLE_PERMISSION_DATA_TABLE}
                    pagination
                    paginationServer
                    paginationTotalRows={totalRows}
                    onChangeRowsPerPage={handlePerRowsChange}
                    onChangePage={handlePageChange}
                  />
                )}
              </div>
            </div>
          </div>
        </div>
      )}
      <CommonModal
        isOpen={open}
        closeModal={() => {
          setOpen(false);
        }}
      >
        <div className="delete_confirmation">
          <div className="text_edit">
            Are you sure want to Delete this{" "}
            <span className="master_coaching_text_edit">
              {itemToDelete?.country_name}
            </span>{" "}
            country ?
          </div>
          <div className="icon_buttons">
            <button
              className="icon_edits icon_yes_color"
              onClick={() => {
                setOpen(false);
                navigate(`/cms/country/${itemToDelete?.id}/delete`);
              }}
            >
              Yes
            </button>
            <button
              className="icon_edits icon_no_color"
              onClick={() => setOpen(false)}
            >
              No
            </button>
          </div>
        </div>
      </CommonModal>
    </>
  );
}

export default Country;
